import { useSelector } from "react-redux";
import { getCategorySeoLinks } from "../../../../../state/modules/category/selectors";
import Pill from "../../../../CategoryHeader/Pill";
import HorizontalScrollList from "../../../../HorizontalScrollList";
import styles from "./index.css";

const SecondaryCategorySeoLinks = () => {
  const { secondarySeoLinks } = useSelector(getCategorySeoLinks);

  if (!secondarySeoLinks.length) return null;

  return (
    <HorizontalScrollList
      isCentralised={true}
      className={styles.secondaryCategorySeoLinks}
    >
      {secondarySeoLinks.map(({ friendlyName, linkUrl }) => (
        <Pill
          key={friendlyName}
          friendlyName={friendlyName}
          linkUrl={linkUrl}
        />
      ))}
    </HorizontalScrollList>
  );
};

export default SecondaryCategorySeoLinks;
